import RefData from 'ref-data';

import { assetRefService } from '../../common/Services';

const allowPublish = (model, isExperiencePublished) =>
  model.status.id !== RefData.Enum.STATUS.CAMPAIGNPROMOTION.PUBLISHED && isExperiencePublished;

const allowDraft = (model, isExperiencePublished) =>
  model.status.id !== RefData.Enum.STATUS.CAMPAIGNPROMOTION.DRAFT && isExperiencePublished;

const promotionImage = (model, isMacroExperience) =>
  // NextGen experience promotion images always show locked images
  // Macro ones are not changed
  !(isMacroExperience && model.isUnlocked)
    ? assetRefService.pathFromAssetRef(model.lockedThumbnailAssetRef)
    : assetRefService.pathFromAssetRef(model.thumbnailAssetRef);

const hasImage = (model, isMacroExperience) =>
  promotionImage(model, isMacroExperience) &&
  // Check for both locked and unlocked images in Macro and only locked one in NextGen
  ((isMacroExperience && (model.thumbnailAssetRef || model.lockedThumbnailAssetRef)) || model.thumbnailAssetRef);

export { allowPublish, allowDraft, promotionImage, hasImage };
